import { render, staticRenderFns } from "./SysConfigForm.vue?vue&type=template&id=45e95e5c&"
import script from "./SysConfigForm.vue?vue&type=script&lang=js&"
export * from "./SysConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports